'use strict';

/* jshint -W098 */
angular.module('mean.messages').controller('MessageComposeController', ['$scope', 'Global', 'Messages', 'Users', 'MeanUser', '$filter', 'MessageReply', 'Upload', '$http', '$location',
  function($scope, Global, Messages, Users, MeanUser, $filter, MessageReply, Upload, $http, $location) {
    $scope.global = Global;
    $scope.package = {
      name: 'messages'
    };

    $scope.total_messages = 0;
    $scope.total_unread = 0;
    $scope.total_inbox = 0;
    $scope.editable = {};
    $scope.users = [];

    $scope.files = [];

    Users.query({}, function(users) {
      $scope.users = users;
    });

    Messages.query({'receiver': MeanUser.user._id, 'where': 'sender subject date folder status'}, function(messages) {
      $scope.my_messages = $filter('orderBy')(messages, '-date', false);
      $scope.my_inbox_messages = $filter('filter')($scope.my_messages, {'folder': 'inbox'}, true);

      $scope.total_messages = $scope.my_messages.length;

      var unread = 0;
      var inbox = 0;
      $scope.my_messages.forEach(function(message) {
        if(message.folder === 'inbox') {
          inbox = inbox + 1;
        
          if(message.status === 'unread') {
            unread = unread + 1;
          }
        }
      });

      $scope.total_inbox = inbox;
      $scope.total_unread = unread;
    });

    $scope.imageUpload = function(files) {
      for(var i=0; i<files.length; i=i+1) {
       $scope.get_signed_request(files[i]);
      }
      //$scope.get_signed_request(files[0]);

      console.log('image upload:', files);
      console.log('image upload\'s editable:', $scope.editable);
    };

    $scope.upload_file = function(file, signed_request, url, new_filename){
        var xhr = new XMLHttpRequest();
        xhr.open("PUT", signed_request);
        xhr.setRequestHeader('x-amz-acl', 'public-read');
        xhr.onload = function() {
            if (xhr.status === 200) {
              console.log('in the if statement of the upload_file function ' + url);
              file.url = url;
              $scope.addFile(file);
              $scope.$apply();
            }
        };
        xhr.onerror = function() {
            alert("Could not upload file.");
        };
        xhr.send(file);

        // $http({
        //   method: 'PUT',
        //   skipAuthorization : true,
        //   headers: {
        //     'x-amz-acl': 'public-read',
        //   },
        //   url: signed_request
        // }).then(function successCallback(response) {
        //     console.log('in the if statement of the upload_file function ' + url);
        //     file.url = url;
        //     $scope.addFile(file);
        //   }, function errorCallback(response) {
        //     alert("Could not upload file.");
        //   });
    };

    $scope.addFile = function(file) {
      $scope.files.push(file);
    };

    $scope.get_signed_request = function(file){
        $http({
          method: 'GET',
          url: '/api/sign_s3?file_name='+file.name+'&file_type='+file.type
        }).then(function successCallback(response) {
            $scope.upload_file(file, response.data.signed_request, response.data.url, response.data.new_filename);
          }, function errorCallback(response) {
            alert("Could not get signed URL.");
          });
    };

    $scope.options = {
            height: 150,
            toolbar: [
              ['style', ['bold', 'italic', 'underline', 'clear']],
              ['color', ['color']],
              ['para', ['ul', 'ol', 'paragraph']],
              ['height', ['height']]
            ]
    };

    $scope.sendMail = function() {
      var ids = [];
      var attach = [];
      if(!$scope.selectedUser) {
        alert('Who is this message to?');
        return;
      }

      var receivers = $filter('filter')($scope.users, {'_id': $scope.selectedUser.originalObject._id}, true);
      receivers.forEach(function(rxer) {
        ids.push(rxer._id);
      });

      if(ids.length === 0) {
        alert('Must select a system user as the receiver');
        return;
      }

      if(!$scope.subject) {
        alert('Please fill in the subject line');
        return;
      }

      $scope.files.forEach(function(file) {
        attach.push({
          name: file.name,
          size: file.size,
          type: file.type,
          url: file.url
        });
      });

      var message = new Messages({
        sender: MeanUser.user._id,
        receiver: ids,
        date: new Date(),
        status: 'unread',
        folder: 'inbox',
        subject: $scope.subject,
        body: $scope.body,
        attachments: attach
      });

      message.$save();
      $location.path('mail');
    };

    $scope.messageReply = function(rf_message) {
      //$scope.selectedUser = rf_message.sender;
      Users.query({}, function(users) {
        var sender = $filter('filter')(users, {'_id': rf_message.sender}, true)[0];
        var receiver = $filter('filter')(users, {'_id': rf_message.receiver[0]}, true)[0];

        $scope.initialValue = sender;
        $scope.subject = 'RE: ' + rf_message.subject;

        $scope.body = '<br><br><br><hr>' +
                      '<br>' + 'sender: ' + sender.name +
                      '<br>' + 'receiver: ' + receiver.name +
                      '<br>' + 'date: ' + rf_message.date + '<br>' +
                      '<br>' + 'subject: ' + rf_message.subject + '<br>' +
                      '<br>' + rf_message.body.replace(new RegExp('<p>', 'g'), '<p> >  ');
      });
    };

    $scope.messageForward = function(rf_message) {
      //$scope.body = rf_message.body;
      Users.query({}, function(users) {
        var sender = $filter('filter')(users, {'_id': rf_message.sender}, true)[0];
        var receiver = $filter('filter')(users, {'_id': rf_message.receiver[0]}, true)[0];

        $scope.subject = 'FWD: ' + rf_message.subject;

        $scope.body = '<br><br><br><hr>' +
                      '<br>' + 'sender: ' + sender.name +
                      '<br>' + 'receiver: ' + receiver.name +
                      '<br>' + 'date: ' + rf_message.date + '<br>' +
                      '<br>' + 'subject: ' + rf_message.subject + '<br>' +
                      '<br>' + rf_message.body.replace(new RegExp('<p>', 'g'), '<p> >  ');
      });
    };

    var rf_message = MessageReply.get();
    if(rf_message.reply) {
      $scope.messageReply(rf_message);
    } else if(rf_message.forward) {
      $scope.messageForward(rf_message);
    } 

  }
]);


// WEBPACK FOOTER //
// ./packages/custom/messages/public/controllers/messageCompose.js